import { FeedbackActionsEnum } from '../enums/FeedbackActionsEnum';
import { IFeedbackState } from '../interfaces/IFeedbackState';
import { FeedbackAction } from '../types/FeedbackAction';

export const initialFeedbackState: IFeedbackState = {
  error: '',
  files: [],
  knmData: undefined,
  planData: undefined,
};

export function feedbackReducer(state = initialFeedbackState, action: FeedbackAction) {
  switch (action.type) {
    case FeedbackActionsEnum.FEEDBACK_RESET: {
      return initialFeedbackState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_ERROR: {
      const { error } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        error,
      };

      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_FILES: {
      const { files } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        files,
      };

      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_FORM: {
      const { form } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        form,
      };

      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_KNM_DATA: {
      const { knmData } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        knmData,
      };

      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_PLAN_DATA: {
      const { planData } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        planData,
      };

      return newState;
    }
    default:
      return state;
  }
}
